import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ApiUrl } from "../../../ApiUrl";
import "./Stdprofile.css";

const emptyProfile = {
  studentName: "",
  admissionNo: "",
  className: "",
  sectionName: "",
  rollNo: "",
  fatherName: "",
  fatherMobile: "",
  motherName: "",
  motherMobile: "",
  aadharNo: "",
  gender: "",
  bloodGroup: "",
  userName: "",
  academicSession: "",
  course: "",
  department: "",
  academicYearLabel: "",
  semester: "",
  dob: "-",
  status: "ACTIVE",
};

const StudentProfileCard = () => {
  const navigate = useNavigate();
  const [profileData, setProfileData] = useState(emptyProfile);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchStudentProfile = async () => {
      const studentId = sessionStorage.getItem("userId");
      const academicYearId = localStorage.getItem("academicSessionId");

      if (!studentId || !academicYearId) {
        setError("Student session details are missing. Please log in again.");
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        setError("");

        const response = await fetch(
          `${ApiUrl.apiurl}STUDENT_PROFILE/GetStudentProfile/${studentId}/?academic_year_id=${academicYearId}`
        );

        const contentType = response.headers.get("content-type") || "";
        const payload = contentType.includes("application/json")
          ? await response.json()
          : null;

        if (!response.ok || !payload || payload.message !== "Success") {
          throw new Error(payload?.message || "Unable to load student profile.");
        }

        const student = payload.data || {};

        setProfileData({
          studentName: student.studentname || "-",
          admissionNo:
            student.admission_no ||
            student.school_admission_no ||
            student.registration_no ||
            "-",
          className: student.classname || "-",
          sectionName: student.sectionname || "-",
          rollNo: student.rollno ?? "-",
          fatherName: student.father_name || "-",
          fatherMobile: student.father_contact_number || "-",
          motherName: student.mother_name || "-",
          motherMobile: student.mother_contact_number || "-",
          aadharNo: student.studentaadharno || "-",
          gender: student.gender || "-",
          bloodGroup: student.bloodgroup || "-",
          userName: student.username || "-",
          academicSession: student.academic_year || "-",
          course: student.classname || "-",
          department: student.sectionname || "-",
          academicYearLabel: student.rollno ? `${student.rollno}` : "-",
          semester: "-",
          dob: student.dob || "-",
          status: "ACTIVE",
        });
      } catch (fetchError) {
        console.error("Error fetching student profile:", fetchError);
        setProfileData(emptyProfile);
        setError(fetchError.message || "Unable to load student profile.");
      } finally {
        setLoading(false);
      }
    };

    fetchStudentProfile();
  }, []);

  const handleClose = () => {
    navigate("/student/dashboards");
  };

  const profileInitial = (profileData.studentName || "S")
    .trim()
    .charAt(0)
    .toUpperCase();

  return (
    <div className="container-fluid student-profile-page">
      <div className="row">
        <div className="col-12">
          <div className="student-profile-shell">
            <div className="student-profile-header">
              <button
                type="button"
                className="btn btn-danger student-profile-close"
                onClick={handleClose}
              >
                Close
              </button>
              <h2 className="student-profile-title">STUDENT PROFILE</h2>
            </div>

            {loading ? (
              <div className="text-center py-4">Loading student profile...</div>
            ) : error ? (
              <div className="alert alert-danger mb-0">{error}</div>
            ) : (
              <>
                <div className="student-profile-main-card">
                  <div className="student-profile-section-title">
                    Student Information
                  </div>

                  <div className="student-profile-main-grid">
                    <div className="student-profile-avatar-wrap">
                      <div className="student-profile-avatar">{profileInitial}</div>
                    </div>

                    <div className="student-profile-info-grid">
                      <div className="student-profile-info-column">
                        <div className="student-profile-field">
                          <span className="student-profile-label">Name:</span>
                          <span className="student-profile-value">{profileData.studentName}</span>
                        </div>
                        <div className="student-profile-field">
                          <span className="student-profile-label">Admission No:</span>
                          <span className="student-profile-value">{profileData.admissionNo}</span>
                        </div>
                        <div className="student-profile-field">
                          <span className="student-profile-label">Registration No:</span>
                          <span className="student-profile-value">{profileData.admissionNo}</span>
                        </div>
                        <div className="student-profile-field">
                          <span className="student-profile-label">Roll No:</span>
                          <span className="student-profile-value">{profileData.rollNo}</span>
                        </div>
                        <div className="student-profile-field">
                          <span className="student-profile-label">Date of Birth:</span>
                          <span className="student-profile-value">{profileData.dob}</span>
                        </div>
                        <div className="student-profile-field">
                          <span className="student-profile-label student-profile-status-label">Status:</span>
                          <span className="student-profile-value student-profile-status-value">{profileData.status}</span>
                        </div>
                        <div className="student-profile-field">
                          <span className="student-profile-label">User Name:</span>
                          <span className="student-profile-value">{profileData.userName}</span>
                        </div>
                      </div>

                      <div className="student-profile-info-column">
                        <div className="student-profile-field">
                          <span className="student-profile-label">Session:</span>
                          <span className="student-profile-value">{profileData.academicSession}</span>
                        </div>
                        <div className="student-profile-field">
                          <span className="student-profile-label">Class:</span>
                          <span className="student-profile-value">{profileData.course}</span>
                        </div>
                        
                        <div className="student-profile-field">
                          <span className="student-profile-label">Section:</span>
                          <span className="student-profile-value">{profileData.sectionName}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="student-profile-other-card">
                  <div className="student-profile-other-title">Other Details</div>
                  <div className="student-profile-other-grid">
                    <div className="student-profile-other-column">
                      <div className="student-profile-other-row">
                        <span className="student-profile-other-label">Father Name:</span>
                        <span className="student-profile-other-value">{profileData.fatherName}</span>
                      </div>
                      <div className="student-profile-other-row">
                        <span className="student-profile-other-label">Mother Name:</span>
                        <span className="student-profile-other-value">{profileData.motherName}</span>
                      </div>
                      <div className="student-profile-other-row">
                        <span className="student-profile-other-label">Aadhar No:</span>
                        <span className="student-profile-other-value">{profileData.aadharNo}</span>
                      </div>
                      <div className="student-profile-other-row">
                        <span className="student-profile-other-label">Gender:</span>
                        <span className="student-profile-other-value">{profileData.gender}</span>
                      </div>
                    </div>

                    <div className="student-profile-other-column">
                      <div className="student-profile-other-row">
                        <span className="student-profile-other-label">Father Mobile No:</span>
                        <span className="student-profile-other-value">{profileData.fatherMobile}</span>
                      </div>
                      <div className="student-profile-other-row">
                        <span className="student-profile-other-label">Mother Mobile No:</span>
                        <span className="student-profile-other-value">{profileData.motherMobile}</span>
                      </div>
                      <div className="student-profile-other-row">
                        <span className="student-profile-other-label">Blood Group:</span>
                        <span className="student-profile-other-value">{profileData.bloodGroup}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default StudentProfileCard;
